import { ref, computed, Ref } from 'vue'
import { defineStore } from 'pinia'

export default defineStore('analysesStore', () => {
  const isRussia: Ref<boolean> = ref(false)
  const analysesCountInCart: Ref<number> = ref(0)
  const isAnalysesAppointmentAvailableInTown: Ref<boolean> = ref(false)

  const isAnalysesAvailable: Ref<boolean> = computed(() => (
    isAnalysesAppointmentAvailableInTown.value && isRussia.value
  ))

  const analysesCountInCartContent: Ref<string> = computed(() => (
    analysesCountInCart.value > 9 ? '9+' : String(analysesCountInCart.value || '')
  ))

  return {
    isRussia,
    analysesCountInCart,
    isAnalysesAvailable,
    analysesCountInCartContent,
    isAnalysesAppointmentAvailableInTown,
  }
})
